export enum FORM_TEXT_TYPES {
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  POSTCODE = 'POSTCODE',
  CREATE_PET = 'CREATE_PET'
}

export const FORM_TEXT_COMPONENT_TYPES = {
  EMAIL: {
    title: 'Let’s start with your email:',
    registerAs: 'email',
    requiredMessage: 'Please add a valid email address',
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    patternMessage: 'Please add a valid email address',
    placeholder: 'Type your email address here'
  },
  NAME: {
    title: 'What’s your name?',
    registerAs: 'name',
    requiredMessage: 'Please insert your name',
    pattern: /.{2,}/,
    patternMessage: 'Please insert a valid name',
    placeholder: 'What would you like us to call you ?'
  },
  POSTCODE: {
    title: 'What’s your Postcode',
    registerAs: 'postcode',
    requiredMessage: 'Please enter a valid postcode',
    pattern: /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/i,
    patternMessage: 'Please enter a valid postcode',
    placeholder: 'Type your postcode here'
  },
  CREATE_PET: {
    title: `What’s your {{petType}}’s name?`,
    registerAs: 'newPet',
    requiredMessage: 'Please input your pet’s name',
    pattern: /.{2,}/,
    patternMessage: 'Please input your pet’s name',
    placeholder: `Type your {{petType}}’s name here`
  }
} as const;
